<template>
    <div>
    <header class="header">
        <img src="./images/TravelAgency_bg.png" alt="">
        <navHeader ref=navHeader></navHeader>
        <div class="dbox">
            <p>{{langtrans().lxhhxh[languageIndex]}}</p>
        </div>
        <div class="points_box">
            <h3>{{langtrans().myccxh[languageIndex]}}</h3>
            <p>{{langtrans().ddjxww[languageIndex]}}</p>
        </div>
    </header>
    <main class="main">
       <ul class="list">
           <li>
               <img src="./images/TravelAgency_icon_01.png" alt="">
               <h4>{{langtrans().cxhhxh[languageIndex]}}</h4>
               <p>{{langtrans().dddjss[languageIndex]}} {{langtrans().ssdwxx[languageIndex]}}</p>
           </li>
           <li>
               <img src="./images/TravelAgency_icon_02.png" alt="">
               <h4>{{langtrans().yjjm[languageIndex]}}</h4>
               <p>24{{langtrans().xsxyy[languageIndex]}} {{langtrans().qqyyqb[languageIndex]}}</p>
           </li>
           <li>
               <img src="./images/TravelAgency_icon_03.png" alt="">
               <h4>{{langtrans().aqgj[languageIndex]}}</h4>
               <p>{{langtrans().lxhhxh[languageIndex]}} {{langtrans().cxhhxh[languageIndex]}}</p>
           </li>
       </ul>
       <p class="btn_node">
           <button @click="setjlhz">{{langtrans().jlhgzz[languageIndex]}}</button>
       </p>
    </main>
		<jlhzBox ref=jlhzBox></jlhzBox>
	<vFooter @performHeader=performHeader></vFooter>
    </div>
</template>

<script>
import langtrans from "@/assets/languagejs/TravelAgency.vue.trans.js";
	import { Message } from "element-ui";
	import constants from "@/util/constants.js";
	import navHeader from '@/components/header/indexHeader'
	import vFooter from '@/components/footer/indexFooter'
	import { postCooperation } from '@/views/axios/api.js';
	import jlhzBox from './jlhz'
 	export default {
		data() {
			return {
				flag: true,
				usertype: "",
				user: "",
				pwd: "",
				form: {},
				successdialog: false,
				dialogFormVisible: false
			};
		},
		components: {
			navHeader,
			vFooter,
			jlhzBox
		},
		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},	
		methods: {
			langtrans(){
				return langtrans
			},
			setjlhz(){
				this.$refs.jlhzBox.setpopShow('true',2)
			},
			performHeader(str){
				this.$refs.navHeader.login(str)
			},			
		}
	};
</script>

<style scoped>
@import url(./css/programme.css);
</style>



// WEBPACK FOOTER //
// src/components/programme/TravelAgency.vue